import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.MonkeyImagesToText.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.MonkeyImagesToText.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.instructions = null;
  this.sentence = [];
  this.choices = [];
};

EDC.Games.MonkeyImagesToText.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.MonkeyImagesToText.Scenes.Main.prototype.constructor = EDC.Games.MonkeyImagesToText.Scenes.Main;

const MITT = EDC.Games.MonkeyImagesToText.Scenes.Main.prototype;

MITT.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

MITT.loadIteration = function () {
  this.addInstructions();
  this.addSentence();
  this.addChoices();
};

MITT.createTemplateUI = function () {
  const frame = this.add.sprite(880, 445, 'frame');
  const monkey = this.add.sprite(1570, 380, 'monkey');
  const title = this.add.sprite(880, 145, 'title');
};

MITT.addInstructions = function () {
  const font = {
    font: `55px ${this.gameConfig.font}`,
  };
  const { instructions } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const instruction = this.add.text(0, 925, instructions, font).setTint(0x00f000);
  instruction.x = (this.game.config.width - instruction.displayWidth) / 2;
  this.instructions = instruction;
};

MITT.addSentence = function () {
  let { sentence } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  sentence = this.make.text({
    x: 880,
    y: 450,
    text: sentence,
    origin: { x: 0.5, y: 0.5 },
    style: {
      font: `55px ${this.gameConfig.font}`,
      wordWrap: { width: 850 },
      lineSpacing: 15,
    },
  });
  let { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  question = this.make.text({
    x: 880,
    y: sentence.y + sentence.displayHeight + 95,
    text: question,
    origin: { x: 0.5, y: 0.5 },
    style: {
      fontFamily: `${this.gameConfig.font}`,
      fontSize: 64,
      wordWrap: { width: 850 },
      lineSpacing: 15,
    },
  });
  this.sentence.push(sentence);
  this.sentence.push(question);
};

MITT.addChoices = function () {
  const { choices } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < choices.length; i++) {
    const container = this.add.container(200, 120 + i * 135);
    container.number = i;
    container.choiceText = choices[i];
    const choice = this.add.sprite(0, 0, choices[i]);
    const banana = this.add.sprite(-choice.displayWidth / 2, 0, 'banana');
    container.add(banana);
    container.add(choice);
    container.setSize(choice.displayWidth, choice.displayHeight);
    this.shakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.25);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.choices.push(container);
  }
};

MITT.shakeAnimation = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: choice.angle - 6,
    duration: 90,
    ease: 'Sine.easeInOut',
    repeat: 5,
    delay: 5000,
    yoyo: true,
    onComplete: this.shakeAnimation.bind(this, choice),
  });
};

MITT.checkAnswer = function (choice) {
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (choice.number === this.choices[correctAnswer - 1].number) {
    this.playCorrect();
    this.choices.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
    });
    choice.getData('markAnim').showMark(true, () => {});
    choice.next.setTint(0x0ffff0);
    this.moveAnswer(choice);
  } else {
    choice.next.setTint(0xff0000);
    choice.shakeAnim.stop();
    choice.angle = 0;
    choice.disableInteractive();
    this.playWrong();
    choice.getData('markAnim').showMark(false, () => {});
  }
};

MITT.moveAnswer = function (choice) {
  const x = this.sentence[1].x + 25;
  const y = this.sentence[1].y + 25;
  const width = this.sentence[1].displayWidth;
  const height = this.sentence[1].displayHeight;
  const font = {
    font: `64px ${this.gameConfig.font}`,
  };
  // this.add.text(x - width / 2, y - height / 2, choice.choiceText, font).setOrigin(0.5);
  const answer = this.add.sprite(x - width / 2, y - height / 2, choice.choiceText).setOrigin(0.5);
  this.flashAnswer(answer);
};

MITT.flashAnswer = function (answer) {
  this.tweens.add({
    targets: answer,
    alpha: 0,
    duration: 400,
    ease: 'Linear',
    repeat: 2,
    yoyo: true,
  });
  this.time.delayedCall(5000, this.nextIteration, [answer], this);
};

MITT.nextIteration = function (answer) {
  answer.destroy();
  this.choices.map(x => x.destroy());
  this.choices = [];
  this.sentence.map(x => x.destroy());
  this.sentence = [];
  this.instructions.destroy();
  this.instructions = null;

  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

export default EDC.Games.MonkeyImagesToText.Scenes.Main;
